import React from 'react';

const InvisibleBar = (props) => {
    return <div className="invisible-bar" {...props}></div>
}

export default InvisibleBar